import Admin from './Admin';
import Customer from './Customer';
import SubCustomer from './SubCustomer';

export default { Admin, Customer, SubCustomer }
